
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const Role = {
  owner: 'owner',
  trainer: 'trainer',
  member: 'member',
  admin: 'admin'
} as const

export type Role = (typeof Role)[keyof typeof Role]


export const LEAD_STATUS = {
  NEW: 'NEW',
  TRIAL: 'TRIAL',
  CONVERTED: 'CONVERTED',
  LOST: 'LOST'
} as const

export type LEAD_STATUS = (typeof LEAD_STATUS)[keyof typeof LEAD_STATUS]


export const LEAD_SOURCE = {
  WALK_IN: 'WALK_IN',
  INSTAGRAM: 'INSTAGRAM',
  REFERRAL: 'REFERRAL',
  GOOGLE: 'GOOGLE',
  WHATSAPP: 'WHATSAPP',
  OTHER: 'OTHER'
} as const

export type LEAD_SOURCE = (typeof LEAD_SOURCE)[keyof typeof LEAD_SOURCE]


export const PAYMENT_METHOD = {
  CASH: 'CASH',
  UPI: 'UPI'
} as const

export type PAYMENT_METHOD = (typeof PAYMENT_METHOD)[keyof typeof PAYMENT_METHOD]


export const EXPENSE_NATURE = {
  FIXED: 'FIXED',
  VARIABLE: 'VARIABLE'
} as const

export type EXPENSE_NATURE = (typeof EXPENSE_NATURE)[keyof typeof EXPENSE_NATURE]


export const EXPENSE_CATEGORY = {
  RENT: 'RENT',
  SALARY: 'SALARY',
  UTILITIES: 'UTILITIES',
  EQUIPMENT: 'EQUIPMENT',
  MAINTENANCE: 'MAINTENANCE',
  MARKETING: 'MARKETING',
  SOFTWARE: 'SOFTWARE',
  SUPPLIES: 'SUPPLIES',
  MISC: 'MISC'
} as const

export type EXPENSE_CATEGORY = (typeof EXPENSE_CATEGORY)[keyof typeof EXPENSE_CATEGORY]


export const EXPENSE_PAYMENT_METHOD = {
  CASH: 'CASH',
  UPI: 'UPI',
  BANK_TRANSFER: 'BANK_TRANSFER'
} as const

export type EXPENSE_PAYMENT_METHOD = (typeof EXPENSE_PAYMENT_METHOD)[keyof typeof EXPENSE_PAYMENT_METHOD]


export const RECURRING_INTERVAL = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY'
} as const

export type RECURRING_INTERVAL = (typeof RECURRING_INTERVAL)[keyof typeof RECURRING_INTERVAL]


export const GENDER = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  OTHER: 'OTHER'
} as const

export type GENDER = (typeof GENDER)[keyof typeof GENDER]


export const CONTACT_RELATION = {
  PARENT: 'PARENT',
  SPOUSE: 'SPOUSE',
  SIBLING: 'SIBLING',
  FRIEND: 'FRIEND',
  TRAINER: 'TRAINER',
  OTHER: 'OTHER'
} as const

export type CONTACT_RELATION = (typeof CONTACT_RELATION)[keyof typeof CONTACT_RELATION]


export const MEMBERSHIP_STATUS = {
  ACTIVE: 'ACTIVE',
  UPCOMING: 'UPCOMING',
  EXPIRED: 'EXPIRED',
  SUSPENDED: 'SUSPENDED',
  CANCELLED: 'CANCELLED',
  ONHOLD: 'ONHOLD'
} as const

export type MEMBERSHIP_STATUS = (typeof MEMBERSHIP_STATUS)[keyof typeof MEMBERSHIP_STATUS]


export const FREEZE_STATUS = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED'
} as const

export type FREEZE_STATUS = (typeof FREEZE_STATUS)[keyof typeof FREEZE_STATUS]


export const DURATION_UNIT = {
  DAY: 'DAY',
  MONTH: 'MONTH',
  YEAR: 'YEAR'
} as const

export type DURATION_UNIT = (typeof DURATION_UNIT)[keyof typeof DURATION_UNIT]


export const AUDIT_LOG_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  BLOCKED: 'BLOCKED'
} as const

export type AUDIT_LOG_STATUS = (typeof AUDIT_LOG_STATUS)[keyof typeof AUDIT_LOG_STATUS]


export const AUTH_EVENT = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAIL: 'LOGIN_FAIL',
  LOGOUT: 'LOGOUT',
  REGISTER_SUCCESS: 'REGISTER_SUCCESS',
  REGISTER_FAIL: 'REGISTER_FAIL',
  PASSWORD_CHANGE: 'PASSWORD_CHANGE',
  SESSION_CREATED: 'SESSION_CREATED',
  SESSION_REFRESHED: 'SESSION_REFRESHED',
  SESSION_REVOKED: 'SESSION_REVOKED'
} as const

export type AUTH_EVENT = (typeof AUTH_EVENT)[keyof typeof AUTH_EVENT]


export const AUDIT_LOG_ENTITY_TYPE = {
  USER: 'USER',
  MEMBER: 'MEMBER',
  PLAN: 'PLAN',
  STAFF: 'STAFF',
  ATTENDANCE: 'ATTENDANCE',
  EXPENSE: 'EXPENSE',
  SESSION: 'SESSION',
  PAYMENT: 'PAYMENT',
  PRODUCT: 'PRODUCT',
  SALE: 'SALE',
  LEAD: 'LEAD',
  GYM: 'GYM',
  SUBSCRIPTION: 'SUBSCRIPTION',
  PLATFORM_PLAN: 'PLATFORM_PLAN',
  ANNOUNCEMENT: 'ANNOUNCEMENT'
} as const

export type AUDIT_LOG_ENTITY_TYPE = (typeof AUDIT_LOG_ENTITY_TYPE)[keyof typeof AUDIT_LOG_ENTITY_TYPE]


export const AUDIT_LOG_ACTION = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  EMAIL_CHANGE: 'EMAIL_CHANGE',
  ACCESS_DENIED: 'ACCESS_DENIED',
  RATE_LIMIT_HIT: 'RATE_LIMIT_HIT',
  EXPORT: 'EXPORT',
  IMPORT: 'IMPORT',
  ROLE_GRANTED: 'ROLE_GRANTED',
  ROLE_REVOKED: 'ROLE_REVOKED',
  INVITE_SENT: 'INVITE_SENT',
  INVITE_ACCEPTED: 'INVITE_ACCEPTED',
  IMPERSONATE_START: 'IMPERSONATE_START',
  IMPERSONATE_END: 'IMPERSONATE_END'
} as const

export type AUDIT_LOG_ACTION = (typeof AUDIT_LOG_ACTION)[keyof typeof AUDIT_LOG_ACTION]


export const BILLING_STATUS = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  OVERDUE: 'OVERDUE',
  CANCELLED: 'CANCELLED'
} as const

export type BILLING_STATUS = (typeof BILLING_STATUS)[keyof typeof BILLING_STATUS]


export const DISCOUNT_TYPE = {
  PERCENTAGE: 'PERCENTAGE',
  FLAT: 'FLAT'
} as const

export type DISCOUNT_TYPE = (typeof DISCOUNT_TYPE)[keyof typeof DISCOUNT_TYPE]


export const PRODUCT_CATEGORY = {
  SUPPLEMENT: 'SUPPLEMENT',
  DRINK: 'DRINK',
  SNACK: 'SNACK',
  ACCESSORY: 'ACCESSORY',
  APPAREL: 'APPAREL',
  OTHER: 'OTHER'
} as const

export type PRODUCT_CATEGORY = (typeof PRODUCT_CATEGORY)[keyof typeof PRODUCT_CATEGORY]


export const NOTIFICATION_TYPE = {
  NEW_LEAD: 'NEW_LEAD',
  NEW_MEMBER: 'NEW_MEMBER',
  LEAVE_REQUEST: 'LEAVE_REQUEST',
  PAYMENT_RECEIVED: 'PAYMENT_RECEIVED',
  LEAD_ASSIGNED: 'LEAD_ASSIGNED',
  LEAVE_APPROVED: 'LEAVE_APPROVED',
  LEAVE_REJECTED: 'LEAVE_REJECTED',
  STAFF_JOINED: 'STAFF_JOINED',
  LOW_STOCK: 'LOW_STOCK'
} as const

export type NOTIFICATION_TYPE = (typeof NOTIFICATION_TYPE)[keyof typeof NOTIFICATION_TYPE]


export const SUBSCRIPTION_STATUS = {
  TRIALING: 'TRIALING',
  ACTIVE: 'ACTIVE',
  PAST_DUE: 'PAST_DUE',
  CANCELED: 'CANCELED'
} as const

export type SUBSCRIPTION_STATUS = (typeof SUBSCRIPTION_STATUS)[keyof typeof SUBSCRIPTION_STATUS]


export const ANNOUNCEMENT_VARIANT = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  CRITICAL: 'CRITICAL'
} as const

export type ANNOUNCEMENT_VARIANT = (typeof ANNOUNCEMENT_VARIANT)[keyof typeof ANNOUNCEMENT_VARIANT]


export const GYM_STATUS = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  ARCHIVED: 'ARCHIVED'
} as const

export type GYM_STATUS = (typeof GYM_STATUS)[keyof typeof GYM_STATUS]


export const LEAVE_TYPE = {
  CASUAL: 'CASUAL',
  SICK: 'SICK',
  OTHER: 'OTHER'
} as const

export type LEAVE_TYPE = (typeof LEAVE_TYPE)[keyof typeof LEAVE_TYPE]


export const LEAVE_STATUS = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING'
} as const

export type LEAVE_STATUS = (typeof LEAVE_STATUS)[keyof typeof LEAVE_STATUS]
